import React, { useEffect, useState } from "react";

import logo from "../../assets/images/logo_64.png";

import "./Splash.css";

const SPLASH_STORAGE_KEY = "katchSplashShown";
const SPLASH_DURATION = 1800;
const EXIT_DURATION = 300;

const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    const hasShownSplash = sessionStorage.getItem(SPLASH_STORAGE_KEY);

    if (hasShownSplash) return;

    sessionStorage.setItem(SPLASH_STORAGE_KEY, "true");
    setIsVisible(true);

    const hideTimer = window.setTimeout(() => {
      setIsLeaving(true);
    }, SPLASH_DURATION);

    const removeTimer = window.setTimeout(() => {
      setIsVisible(false);
    }, SPLASH_DURATION + EXIT_DURATION);

    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(removeTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div
      className={["splash-screen", isLeaving && "splash-screen--leaving"]
        .filter(Boolean)
        .join(" ")}
      role="status"
      aria-label="Loading Katch"
    >
      <div className="splash-screen__content">
        <div className="splash-screen__logo-wrapper">
          <img src={logo} alt="" className="splash-screen__logo" />
        </div>

        <div className="splash-screen__brand">
          <span className="splash-screen__title">Katch</span>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
